
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chessparty/tv",
      function () {
        return require("private-next-pages/chessparty/tv.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chessparty/tv"])
      });
    }
  